import { Typography, Box } from '@mui/material';
import { BaseInput, BaseButton } from '../base';
import { useTheme } from '@mui/material';
import { useState, useEffect, useRef } from 'react';
import useProtectedClient from '../../hooks/useProtectedClient';
import { getProductPrice } from '../../api/order/orderApi';
import { useNavigate } from "react-router-dom";
import URIs from '../../utils/uri';
import { useNotification } from '../../context/NotificationProvider'
import { createOrder } from '../../api/order/orderApi';
import { numberToTomans } from '../../utils/helpers';

const SellProduct = ({ productId }) => {
    const theme = useTheme();
    const protectedClient = useProtectedClient();
    const productDetails = useRef({})
    const productPrice = useRef({})
    const [count, setCount] = useState("");
    const [amount, setAmount] = useState("");
    const [isLoading, setIsloading] = useState(false);
    const navigate = useNavigate();
    const {showNotification} = useNotification();

    const handleCountChange = (e) => {
        setCount(e.target.value);
        setAmount(e.target.value * productPrice.current)
    };

    const handleSubmit = async () => {
    
        setIsloading(true);
        try {
            await createOrder(protectedClient, productId, count, null, 'sell')
            showNotification("سفارش با موفقیت ثبت شد", "success");
            navigate(URIs.TRANSACTOINS);
        } catch (error) {
            showNotification(error, "error");
        } finally {
            setIsloading(false);
        }
    };

    useEffect( () => {
        const fetchPrice = async () => {
            setIsloading(true);
            try {
                const res = await getProductPrice(protectedClient, productId);
                productDetails.current = res
                productPrice.current = Math.round(productDetails.current.sellPrice)
            } catch (error) {
                showNotification(error, "error");
            } finally {
                setIsloading(false);
            }
        };
        fetchPrice();
    }, []);
    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            alignItems="center"
            padding={2}
            sx={{ height: "90vh", width: "100%", paddingTop: "80px" }}
        >
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="flex-start"
                alignItems="center"
                gap={2}
                sx={{ width: "90%", flexGrow: 1 }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        borderRadius: '10px',
                        border: '1px solid',
                        padding: '10px',
                        background: theme.palette.background.paper,
                    }}
                >
                    <Typography
                        variant='subtitle'
                    >
                        قیمت فروش:
                    </Typography>
                    <Typography
                        variant='subtitle'
                    >
                        {numberToTomans(productDetails.current?.sellPrice || 0)} تومان
                    </Typography>
                </Box>
                <Box sx={{ width: "100%" }}>
                    <BaseInput
                        label="تعداد را وارد کنید"
                        value={count}
                        onChange={handleCountChange}
                        name="count"
                        type="number"
                    />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        borderRadius: '10px',
                        border: '1px solid',
                        padding: '10px',
                        background: theme.palette.background.paper,
                    }}
                >
                    <Typography
                        variant='subtitle'
                    >
                        مبلغ کل:
                    </Typography>
                    <Typography
                        variant='subtitle'
                    >
                        {numberToTomans(amount)} تومان
                    </Typography>
                </Box>
            </Box>

            <BaseButton
                sx={{
                    width: "90%",
                }}
                disabled={!count || count === "0" }
                isLoading={isLoading}
                onClick={handleSubmit}
            >
                ثبت سفارش
            </BaseButton>
        </Box>
    );
};

export default SellProduct;
